module.exports = __webpack_public_path__ + "img/facebook_phone.765b7fba.png";